import { render, staticRenderFns } from "./colsort.vue?vue&type=template&id=28c29f20&scoped=true&"
import script from "./colsort.vue?vue&type=script&lang=js&"
export * from "./colsort.vue?vue&type=script&lang=js&"
import style0 from "./colsort.vue?vue&type=style&index=0&id=28c29f20&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c29f20",
  null
  
)

export default component.exports